// material-ui
import Stack from "@mui/material/Stack";

export default function Footer() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ p: "24px 16px 0px", mt: "auto" }}
    >
      {/* Copyright &copy; {new Date().getFullYear() - 1}-
      {new Date().getFullYear().toString().substring(2)} GN Library All Rights
      Reserved */}
    </Stack>
  );
}
